import ContactMailIcon from '@mui/icons-material/ContactMail';

import ContactList from './ContactList';
import ContactCreate from './ContactCreate';
import ContactShow from './ContactShow';
import ContactEdit from './ContactEdit';

const contacts = {
	list: ContactList,
	create: ContactCreate,
	show: ContactShow,
	edit: ContactEdit,
	icon: ContactMailIcon,
};

export default contacts;
